var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "attendance-title" } },
    [
      _c("span", {
        domProps: { innerHTML: _vm._s(_vm.$t("mypage.attendance.title")) },
      }),
      _c(
        "button",
        {
          staticClass: "d-flex align-items-center ml-1",
          attrs: { id: `${_vm.sideBar}attendance-img` },
        },
        [
          _c("img", {
            staticClass: "attendance",
            attrs: {
              src: `${_vm.$s3}/img/common/lotto/question.svg?${_vm.$ver}`,
            },
          }),
        ]
      ),
      _c(
        "b-tooltip",
        {
          attrs: {
            target: `${_vm.sideBar}attendance-img`,
            "no-fade": "",
            triggers: "hover",
            "custom-class": "tooltip-middle",
          },
        },
        [
          _c("div", { attrs: { id: "attendance-tooltip" } }, [
            _c("div", {
              staticStyle: { "text-align": "center" },
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("mypage.attendance.count", {
                    cnt_attendance: _vm.cntAttendance,
                  })
                ),
              },
            }),
            _c("div", { staticClass: "attendance_info paragraph" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("mypage.attendance.content")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("mypage.attendance.content1")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("mypage.attendance.content2")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("mypage.attendance.content3")))]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }